import styled from 'styled-components';
import {
  Dropdown as SemanticDropdown,
  Message as SemanticMessage,
} from 'semantic-ui-react';
import { Loader as LoaderLayoutComponent } from '@playbookux/playbook-web-core';

const Dropdown = styled(SemanticDropdown)`
  margin-right: 20px;

  &.ui.dropdown > .text {
    color: ${(props) => props.theme.color.primary};
    font-weight: 500;
  }
`;

const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-bottom: 40px;
`;

const Loader = styled(LoaderLayoutComponent)`
`;

const CenteredLoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const Message = styled(SemanticMessage)`
`;

export {
  Dropdown,
  Header,
  Loader,
  CenteredLoaderContainer,
  Message,
};

export const FeatureFlagLine = styled.div`
`;
